import React from "react";
import cn from "classnames";
import { CSSTransition, TransitionGroup } from 'react-transition-group';

// * Local
import { PlatformProps } from './Platform.interface';
import { getPlatformFeatures } from "./PlatformFunctionsConfig";

// * Styles
import styles from './Platform.module.css';

const Platform: React.FC<PlatformProps> = ({
  icon,
  platformType,
  name,
  onClick,
  isDisabled
}) => {
  const features = platformType ? getPlatformFeatures(platformType) : [];

  return (
    <button
      className={cn(
        styles.platform,
        {[styles.platform_disabled]: isDisabled}
      )}
      onClick={onClick}
      disabled={isDisabled}
    >
      <div className={styles.platform__normal}>
        <div className={styles.platform__icon}>{icon}</div>
        <p className={styles.platform__name}>{name}</p>
      </div>

      <div className={styles.platform__info}>
        <h3 className={styles.platform__title}>{name}</h3>
        <div className={styles.platform__features}>
          <TransitionGroup component="div" className={styles.platform__list}>
            {features.map((feature, index) => (
              <CSSTransition
                key={feature.id}
                timeout={300}
                classNames={{
                  enter: styles.item_enter,
                  enterActive: styles.item_enter_active,
                }}
              >
                <div className={styles.platform__item}>
                  <div className={styles.platform__text}>{feature.name}</div>
                </div>
              </CSSTransition>
            ))}
          </TransitionGroup>
        </div>
      </div>
    </button>
  );
};

export default Platform;